module.exports = __webpack_public_path__ + "img/icon-public-club.39111435.png";